import React, { useState, useEffect } from "react";
import { Button, Form, Card, Row, Col, Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import defaultImg from "./../../../images/task/img1.jpg";
import { var_api, image_api } from "../../../constant";
import Select from "react-select";

const ProductMaster = () => {

  const tableHeaders = ["#", "Image", "Product", "Code", "UOM", "Available Count", "Available Weight", "Unit Price", "Profit(%)", "Final Price", "Is coldcut","Status", "Action+ Add Variant"];

  const [productData, setProductData] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [errors, setErrors] = useState({});
  const [showImageModal, setShowImageModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(''); 

  const [uomData, setUomData] = useState([
    { uom_name: "gm" },
    { uom_name: "kg" }
  ]);

  const [showForm, setShowForm] = useState(false);
  const [showVariantModal, setShowVariantModal] = useState(false);
  const [showVariantListModal, setShowVariantListModal] = useState(false);
  const [selectedProductForVariant, setSelectedProductForVariant] = useState(null);
  const [variants, setVariants] = useState([]);
  const [variantFile, setVariantFile] = useState(null);
  const [isEditVariantMode, setIsEditVariantMode] = useState(false);
  const itemsPerPage = 15;
  const navigate = useNavigate();
  const [showCancelConfirm, setShowCancelConfirm] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const warehouse_id = localStorage.getItem("warehouse_id");

  const [formData, setFormData] = useState({
    business_id: 0,
    cat_id: "",
    veemart_product_code: "",
    product_name: "",
    product_image: "",
    description: "",
    is_variant: 0,
    uom: "",
    gross_weight: "",
    net_weight: 0,
    qty_count: "",
    unit_price: "",
    additional_note: "",
    active_status: 1,
    business_profit: "",
    final_selling_price: "",
    warehouse_id: warehouse_id,
    is_cold_cuts: 0
  });

  const [variantFormData, setVariantFormData] = useState({
    cat_id: "",
    product_id: "",
    veemart_variant_code: "",
    variant_name: "",
    variant_image: "",
    description: "",
    uom: "",
    gross_weight: "",
    net_weight: "",
    qty_count: "",
    additional_note: "",
    active_status: 1,
    unit_price: "",
    business_profit: "",
    final_selling_price: ""
  });

  const [catName, setCatName] = useState("");

  useEffect(() => {
    setCatName(localStorage.getItem("cat_name") || "");
    fetchProductData();
    fetchCategoryData();
  }, []);

  const fetchProductData = async () => {
    try {
      const warehouseId = localStorage.getItem("warehouse_id") || "";

      const res = await axios.get(
        `${var_api}sa_veemart_product_master/getbywarehouse/${warehouseId}`
      );

      const allProducts = Array.isArray(res.data)
        ? res.data
        : Array.isArray(res.data.data)
        ? res.data.data
        : [];

      // Fetch variant count for each product that is cold cuts
      const productsWithVariantCount = await Promise.all(
        allProducts.map(async (product) => {
          if (product.is_cold_cuts === 1) {
            try {
              const variantRes = await axios.get(
                `${var_api}sa_veemart_variant_master/getbyvariantbyproductid/${product.id}`
              );
              const variantCount = Array.isArray(variantRes.data) ? variantRes.data.length : 0;
              return { ...product, variant_count: variantCount };
            } catch (err) {
              return { ...product, variant_count: 0 };
            }
          }
          return { ...product, variant_count: 0 };
        })
      );

      setProductData(productsWithVariantCount);
    } catch (err) {
      toast.error("Failed to fetch product data");
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchCategoryData = async () => {
    try {
      const warehouse_id = localStorage.getItem("warehouse_id");

      const res = await axios.get(
        `${var_api}sa_veemart_category_master/getactiveCategorybywarehouse/${warehouse_id}`
      );

      setCategoryData(res.data || []);
    } catch (err) {
      console.error("Failed to fetch category data", err);
    }
  };

  const fetchVariantsByProductId = async (product_id) => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/getbyvariantbyproductid/${product_id}`);
      setVariants(res.data || []);
    } catch (err) {
      console.error("Failed to fetch variants", err);
      setVariants([]);
    }
  };

  const calculateFinalPrice = (unitPrice, profitPercent) => {
    const price = parseFloat(unitPrice) || 0;
    const profit = parseFloat(profitPercent) || 0;
    return (price + (price * profit / 100)).toFixed(2);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...formData, [name]: value };

    if (name === "unit_price" || name === "business_profit") {
      updatedData.final_selling_price = calculateFinalPrice(
        name === "unit_price" ? value : formData.unit_price,
        name === "business_profit" ? value : formData.business_profit
      );
    }

    setFormData(updatedData);
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleVariantInputChange = (e) => {
    const { name, value } = e.target;
    let updatedData = { ...variantFormData, [name]: value };

    if (name === "unit_price" || name === "business_profit") {
      updatedData.final_selling_price = calculateFinalPrice(
        name === "unit_price" ? value : variantFormData.unit_price,
        name === "business_profit" ? value : variantFormData.business_profit
      );
    }

    setVariantFormData(updatedData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!formData.product_name.trim()) newErrors.product_name = "Product name is required";
    if (!formData.uom.trim()) newErrors.uom = "Uom is required";

    if (!file && !formData.product_image) newErrors.product_image = "Image is required";
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      toast.warning("Please correct highlighted fields");
      return;
    }

    try {
      setLoading(true);
      const form = new FormData();

      Object.entries({
        business_id: 0,
        cat_id: formData.cat_id,
        veemart_product_code: formData.veemart_product_code || "",
        product_name: formData.product_name,
        description: formData.description || "",
        is_variant: formData.is_variant || 0,
        uom: formData.uom || "",
        gross_weight: formData.gross_weight || "",
        net_weight: formData.net_weight || "",
        qty_count: formData.qty_count || "",
        unit_price: formData.unit_price || "",
        additional_note: formData.additional_note || "",
        active_status: formData.active_status ?? 1,
        business_profit: formData.business_profit || "",
        final_selling_price: formData.final_selling_price || 0,
        warehouse_id: formData.warehouse_id,
        is_cold_cuts: formData.is_cold_cuts || 0
      }).forEach(([key, val]) => form.append(key, val));

      if (file) form.append("product_image", file);
      else if (formData.product_image) form.append("product_image", formData.product_image);

      const headers = { headers: { "Content-Type": "multipart/form-data" } };
      let res;

      if (isEditMode && formData.id) {
        res = await axios.put(`${var_api}sa_veemart_product_master/update/${formData.id}`, form, headers);
      } else {
        res = await axios.post(`${var_api}sa_veemart_product_master/post`, form, headers);
      }

      toast.success(res?.data?.message);
      setShowForm(false);
      setFile(null);
      fetchProductData();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save data");
    } finally {
      setLoading(false);
    }
  };

  const handleVariantSubmit = async (e) => {
    e.preventDefault();
    try {
      const form = new FormData();

      Object.entries({
        cat_id: selectedProductForVariant.cat_id,
        product_id: selectedProductForVariant.id,
        veemart_variant_code: variantFormData.veemart_variant_code || "",
        variant_name: variantFormData.variant_name,
        description: variantFormData.description || "",
        uom: variantFormData.uom || "",
        gross_weight: variantFormData.gross_weight || "",
        net_weight: variantFormData.net_weight || "",
        qty_count: variantFormData.qty_count || "",
        additional_note: variantFormData.additional_note || "",
        active_status: variantFormData.active_status ?? 1,
        unit_price: variantFormData.unit_price || "",
        business_profit: variantFormData.business_profit || "",
        final_selling_price: variantFormData.final_selling_price || ""
      }).forEach(([key, val]) => form.append(key, val));

      if (variantFile) form.append("variant_image", variantFile);
      else if (variantFormData.variant_image) form.append("variant_image", variantFormData.variant_image);

      const headers = { headers: { "Content-Type": "multipart/form-data" } };
      
      if (isEditVariantMode && variantFormData.id) {
        await axios.put(`${var_api}sa_veemart_variant_master/update/${variantFormData.id}`, form, headers);
        toast.success("Variant updated successfully!");
      } else {
        await axios.post(`${var_api}sa_veemart_variant_master/post`, form, headers);
        toast.success("Variant added successfully!");
      }

      setShowVariantModal(false);
      setVariantFile(null);
      setIsEditVariantMode(false);
      setVariantFormData({
        cat_id: "",
        product_id: "",
        veemart_variant_code: "",
        variant_name: "",
        variant_image: "",
        description: "",
        uom: "",
        gross_weight: "",
        net_weight: "",
        qty_count: "",
        additional_note: "",
        active_status: 1,
        unit_price: "",
        business_profit: "",
        final_selling_price: ""
      });
      fetchProductData();
      
      // Refresh variants list if modal is open
      if (showVariantListModal && selectedProductForVariant) {
        await fetchVariantsByProductId(selectedProductForVariant.id);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to save variant");
    }
  };

  const handleEditClick = (item) => {
    setFormData({ ...item });
    setFile(null);
    setIsEditMode(true);
    setErrors({});
    setShowForm(true);
  };

  const handleAddVariantClick = (product) => {
    setSelectedProductForVariant(product);
    setIsEditVariantMode(false);
    setVariantFormData({
      cat_id: "",
      product_id: "",
      veemart_variant_code: "",
      variant_name: "",
      variant_image: "",
      description: "",
      uom: "",
      gross_weight: "",
      net_weight: "",
      qty_count: "",
      additional_note: "",
      active_status: 1,
      unit_price: "",
      business_profit: "",
      final_selling_price: ""
    });
    setVariantFile(null);
    setShowVariantModal(true);
  };

  const handleEditVariantClick = (variant) => {
    setVariantFormData({ ...variant });
    setIsEditVariantMode(true);
    setVariantFile(null);
    setShowVariantModal(true);
    setShowVariantListModal(false);
  };

  const handleViewVariantsClick = async (product) => {
    setSelectedProductForVariant(product);
    await fetchVariantsByProductId(product.id);
    setShowVariantListModal(true);
  };

  const filteredData = productData.filter((item) =>
    Object.values(item).some((val) => String(val).toLowerCase().includes(searchQuery.toLowerCase()))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  return (
    <>
      <Card>
        <Card.Body>
          {!showForm && (
            <div className="d-flex align-items-center gap-2 mb-3">
              <Button
                variant="light"
                onClick={() => navigate(-1)}
                className="shadow-sm"
              >
                <i className="fas fa-arrow-left"></i>
              </Button>
              <h5 className="mb-0">
                Product Master
                <br></br>
                <strong>Category:</strong>{" "} 
                <span style={{ color: "blue" }}>{catName}</span> 
              </h5>
            </div>
          )}

          {!showForm ? (
            <>
              <div className="d-flex justify-content-end mb-3 gap-2">
                <input
                  type="text"
                  className="form-control w-auto"
                  placeholder="Search product..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                />
                <Button variant="secondary" onClick={() => {
                  setFormData({
                    business_id: 0,
                    cat_id: "",
                    veemart_product_code: "",
                    product_name: "",
                    product_image: "",
                    description: "",
                    is_variant: 0,
                    uom: "",
                    gross_weight: "",
                    net_weight: "",
                    qty_count: "",
                    unit_price: "",
                    additional_note: "",
                    active_status: 1,
                    business_profit: "",
                    final_selling_price: "",
                    warehouse_id: warehouse_id,
                    is_cold_cuts: 0
                  });
                  setIsEditMode(false);
                  setShowForm(true);
                }}>
                  Add
                </Button>
              </div>

              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>{tableHeaders.map((header, idx) => <th key={idx}>{header}</th>)}</tr>
                  </thead>
                  <tbody>
                    {paginatedData.length === 0 ? (
                      <tr><td colSpan="15" className="text-center text-muted py-3">No data found</td></tr>
                    ) : (
                      paginatedData.map((item, idx) => (
                        <tr key={item.id}>
                          <td>{(currentPage - 1) * itemsPerPage + idx + 1}</td>
                          <td>
                            <img
                              src={item.product_image ? `${image_api}${item.product_image.replace(/^test\//, '')}` : defaultImg}
                              alt="category"
                              width="40"
                              height="40"
                              className="rounded"
                              onClick={() => {
                                setPreviewImage(`${image_api}${item.product_image.replace(/^test\//, '')}`);
                                setShowImageModal(true);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          </td>
                          <td>{item.product_name}</td>
                          <td>{item.veemart_product_code || "-"}</td>
                          <td>{item.uom || "-"}</td>
                          <td>{item.qty_count || "-"}</td>
                          <td>{item.gross_weight || "-"}</td>
                          <td>{item.unit_price || "-"}</td>
                          <td>{item.business_profit || "-"}</td>
                          <td>{item.final_selling_price || "-"}</td>
                          <td>
                            <span className={`badge ${item.is_cold_cuts === 1 ? "bg-info" : "bg-secondary"}`}>
                              {item.is_cold_cuts === 1 ? "Yes" : "No"}
                            </span>
                          </td>
                          <td>
                            <span className={`badge ${item.active_status === 1 ? "bg-success" : "bg-danger"}`}>
                              {item.active_status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            {item.is_cold_cuts === 1 ? (
                              <div className="d-flex gap-1">
                                <Button
                                  size="sm"
                                  variant="primary"
                                  className="d-flex align-items-center gap-1"
                                  onClick={() => handleAddVariantClick(item)}
                                >
                                  <i className="fas fa-plus"></i>
                                  <span>Add</span>
                                </Button>

                                <Button
                                  size="sm"
                                  variant="info"
                                  className="d-flex align-items-center gap-1"
                                  onClick={() => handleViewVariantsClick(item)}
                                >
                                  <span>View ({item.variant_count || 0})</span>
                                </Button>
                              </div>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        
                          <td>
                            <Link
                              to="#"
                              className="btn shadow btn-xs sharp me-1"
                              style={{
                                backgroundColor: "#007bff",
                                color: "white",
                              }}
                              onClick={() => handleEditClick(item)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Link>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              <div className="d-flex justify-content-end mt-3">
                {[...Array(totalPages)].map((_, idx) => (
                  <Button
                    key={idx}
                    variant={currentPage === idx + 1 ? "primary" : "light"}
                    onClick={() => setCurrentPage(idx + 1)}
                    className="me-1"
                  >
                    {idx + 1}
                  </Button>
                ))}
              </div>
            </>
          ) : (
            <Card className="shadow-sm border-0 rounded-3">
              <Card.Body>
                <div className="d-flex align-items-center justify-content-between mb-4 border-bottom pb-2">
                  <h5 className="mb-0 fw-bold text">
                    {isEditMode ? "✏️ Edit Product" : "+ Add New Product"}
                  </h5>
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      setFormData({
                        business_id: 0,
                        cat_id: "",
                        veemart_product_code: "",
                        product_name: "",
                        product_image: "",
                        description: "",
                        is_variant: 0,
                        uom: "",
                        gross_weight: "",
                        net_weight: "",
                        qty_count: "",
                        unit_price: "",
                        additional_note: "",
                        active_status: 1,
                        business_profit: "",
                        final_selling_price: "",
                        warehouse_id: warehouse_id,
                        is_cold_cuts: 0
                      });
                      setIsEditMode(false);
                      setErrors({});
                      setFile(null);
                      setShowForm(false);
                    }}
                    style={{ fontSize: "16px", color: "#007bff" }}
                  >
                    <i className="fas fa-arrow-left"></i>
                    <span className="fw-semibold">Back to List</span>
                  </Button>
                </div>

                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Category <span className="text-danger">*</span>
                        </Form.Label>

                        <Select
                          name="cat_id"
                          value={
                            categoryData
                              .map((c) => ({ label: c.veemart_category_name, value: c.id }))
                              .find((opt) => opt.value == formData.cat_id) || null
                          }
                          onChange={(selected) =>
                            setFormData({ ...formData, cat_id: selected ? selected.value : "" })
                          }
                          options={categoryData.map((c) => ({
                            label: c.veemart_category_name,
                            value: c.id,
                          }))}
                          placeholder="-- Select Category --"
                          isClearable
                          isSearchable
                          classNamePrefix="react-select"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Upload Image <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) => setFile(e.target.files[0])}
                          className="rounded-2 shadow-sm"
                        />
                        {(formData.product_image || file) && (
                          <div className="mt-2">
                            <img
                              src={file ? URL.createObjectURL(file) : `${image_api}${formData.product_image.replace(/^test\//, "")}`}
                              alt="Preview"
                              width="100"
                              height="100"
                              className="border rounded-3 shadow-sm"
                            />
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">UOM <span className="text-danger">*</span></Form.Label>
                        <Select
                          name="uom"
                          value={uomData
                            .map((u) => ({ label: u.uom_name, value: u.uom_name }))
                            .find((option) => option.value === formData.uom) || null}
                          onChange={(selectedOption) =>
                            setFormData({ ...formData, uom: selectedOption ? selectedOption.value : "" })
                          }
                          options={uomData.map((u) => ({ label: u.uom_name, value: u.uom_name }))}
                          placeholder="-- Select UOM --"
                          isClearable
                          isSearchable
                          classNamePrefix="react-select"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">
                          Product Name <span className="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          name="product_name"
                          value={formData.product_name}
                          onChange={handleInputChange}
                          placeholder="Enter Product Name"
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Product Code</Form.Label>
                        <Form.Control
                          name="veemart_product_code"
                          value={formData.veemart_product_code}
                          onChange={handleInputChange}
                          placeholder="Enter Product Code"
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Cold Cuts</Form.Label>
                        <div>
                          <Form.Check
                            type="checkbox"
                            id="cold-cuts-checkbox"
                            label="Is Cold Cuts Product"
                            checked={!!formData.is_cold_cuts}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                is_cold_cuts: e.target.checked ? 1 : 0,
                              })
                            }
                          />
                        </div>
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Unit Price</Form.Label>
                        <Form.Control
                          type="number"
                          name="unit_price"
                          value={formData.unit_price}
                          onChange={handleInputChange}
                          placeholder="Enter Unit Price"
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Profit (%)</Form.Label>
                        <Form.Control
                          type="number"
                          name="business_profit"
                          value={formData.business_profit}
                          onChange={handleInputChange}
                          placeholder="Enter Profit %"
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Final Selling Price</Form.Label>
                        <Form.Control
                          type="number"
                          name="final_selling_price"
                          value={formData.final_selling_price}
                          placeholder="Enter Selling Price"
                          onChange={handleInputChange}
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Qty Count</Form.Label>
                        <Form.Control
                          name="qty_count"
                          value={formData.qty_count}
                          onChange={handleInputChange}
                          placeholder="Enter Quantity Count"
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Additional Note</Form.Label>
                        <Form.Control
                          name="additional_note"
                          value={formData.additional_note}
                          onChange={handleInputChange}
                          placeholder="Add any note"
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>

                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold">Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          name="description"
                          value={formData.description}
                          placeholder="Enter description"
                          onChange={handleInputChange}
                          rows={3}
                          className="rounded-2 shadow-sm"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <div className="d-flex justify-content-end gap-3 mt-4">
                    {!isEditMode && (
                      <>
                        <Button
                          variant="secondary"
                          type="submit"
                          disabled={loading}
                          className="px-4 shadow-sm fw-semibold"
                        >
                          Create
                        </Button>

                        <Button
                          variant="warning"
                          onClick={() =>
                            setFormData({
                              business_id: 0,
                              cat_id: "",
                              veemart_product_code: "",
                              product_name: "",
                              product_image: "",
                              description: "",
                              is_variant: 0,
                              uom: "",
                              gross_weight: "",
                              net_weight: "",
                              qty_count: "",
                              unit_price: "",
                              additional_note: "",
                              active_status: 1,
                              business_profit: "",
                              final_selling_price: "",
                              warehouse_id: warehouse_id,
                              is_cold_cuts: 0
                            })
                          }
                          className="px-4 shadow-sm fw-semibold text-white"
                        >
                          Reset
                        </Button>

                        <Button
                          variant="danger"
                          onClick={() => setShowCancelConfirm(true)}
                          className="px-4 shadow-sm fw-semibold"
                        >
                          Cancel
                        </Button>
                      </>
                    )}

                    {isEditMode && (
                      <>
                        <Button
                          variant="warning"
                          type="submit"
                          disabled={loading}
                          className="px-4 shadow-sm fw-semibold"
                        >
                          Update
                        </Button>

                        <Button
                          variant="danger"
                          onClick={() => setShowCancelConfirm(true)}
                          className="px-4 shadow-sm fw-semibold"
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  </div>
                </Form>
              </Card.Body>
            </Card>
          )}

          <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered size="md">
            <Modal.Header closeButton>
              <Modal.Title>Image Preview</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
              <img
                src={previewImage}
                alt="Preview"
                style={{ width: "100%", borderRadius: "10px" }}
                className="shadow"
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowImageModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showCancelConfirm}
            onHide={() => setShowCancelConfirm(false)}
            centered
          >
            <Modal.Header closeButton className="border-0">
              <Modal.Title className="text-danger fw-bold d-flex align-items-center">
                <i className="fas fa-exclamation-triangle me-2 text-warning"></i>
                Leave this page?
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <p className="mb-0">
                If you leave, your unsaved changes will be discarded.
              </p>
            </Modal.Body>

            <Modal.Footer className="border-0">
              <button
                className="stay-btn"
                onClick={() => setShowCancelConfirm(false)}
              >
                Stay Here
              </button>
              <button
                className="leave-btn"
                onClick={() => {
                  setShowCancelConfirm(false);
                  setShowForm(false);
                }}
              >
                Leave & Discard Changes
              </button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showVariantModal}
            onHide={() => {
              setShowVariantModal(false);
              setIsEditVariantMode(false);
              setVariantFile(null);
            }}
            size="lg"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {isEditVariantMode ? "Edit Variant" : `Add Variant for ${selectedProductForVariant?.product_name}`}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form onSubmit={handleVariantSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Variant Name *</Form.Label>
                      <Form.Control
                        name="variant_name"
                        value={variantFormData.variant_name}
                        onChange={handleVariantInputChange}
                        placeholder="Enter variant name"
                        required
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Variant Code</Form.Label>
                      <Form.Control
                        name="veemart_variant_code"
                        value={variantFormData.veemart_variant_code}
                        onChange={handleVariantInputChange}
                        placeholder="Enter variant code"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Upload Image</Form.Label>
                      <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) => setVariantFile(e.target.files[0])}
                      />
                      {(variantFormData.variant_image || variantFile) && (
                        <div className="mt-2">
                          <img
                            src={
                              variantFile
                                ? URL.createObjectURL(variantFile)
                                : `${image_api}${variantFormData.variant_image.replace(/^test\//, "")}`
                            }
                            alt="Preview"
                            width="80"
                            height="80"
                            className="border rounded"
                          />
                        </div>
                      )}
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>UOM</Form.Label>
                      <Select
                        name="uom"
                        value={uomData
                          .map((u) => ({ label: u.uom_name, value: u.uom_name }))
                          .find((option) => option.value === variantFormData.uom) || null}
                        onChange={(selectedOption) =>
                          setVariantFormData({ ...variantFormData, uom: selectedOption ? selectedOption.value : "" })
                        }
                        options={uomData.map((u) => ({ label: u.uom_name, value: u.uom_name }))}
                        placeholder="-- Select UOM --"
                        isClearable
                        isSearchable
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Gross Weight</Form.Label>
                      <Form.Control
                        name="gross_weight"
                        value={variantFormData.gross_weight}
                        onChange={handleVariantInputChange}
                        placeholder="Enter gross weight"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Qty Count</Form.Label>
                      <Form.Control
                        name="qty_count"
                        value={variantFormData.qty_count}
                        onChange={handleVariantInputChange}
                        placeholder="Enter quantity"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Unit Price</Form.Label>
                      <Form.Control
                        type="number"
                        name="unit_price"
                        value={variantFormData.unit_price}
                        onChange={handleVariantInputChange}
                        placeholder="Enter unit price"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Business Profit (%)</Form.Label>
                      <Form.Control
                        type="number"
                        name="business_profit"
                        value={variantFormData.business_profit}
                        onChange={handleVariantInputChange}
                        placeholder="Enter profit %"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Final Selling Price</Form.Label>
                      <Form.Control
                        type="number"
                        name="final_selling_price"
                        value={variantFormData.final_selling_price}
                        onChange={handleVariantInputChange}
                        placeholder="Enter selling price"
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="description"
                        value={variantFormData.description}
                        onChange={handleVariantInputChange}
                        placeholder="Enter description"
                        rows={3}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>Additional Note</Form.Label>
                      <Form.Control
                        name="additional_note"
                        value={variantFormData.additional_note}
                        onChange={handleVariantInputChange}
                        placeholder="Add any note"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <div className="d-flex justify-content-end gap-2">
                  <Button variant="secondary" onClick={() => {
                    setShowVariantModal(false);
                    setIsEditVariantMode(false);
                    setVariantFile(null);
                  }}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit">
                    {isEditVariantMode ? "Update Variant" : "Add Variant"}
                  </Button>
                </div>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
            show={showVariantListModal}
            onHide={() => setShowVariantListModal(false)}
            size="xl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Variants for: {selectedProductForVariant?.product_name}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {variants.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-box-open fa-3x text-muted mb-3"></i>
                  <p className="text-muted">No variants found for this product.</p>
                  <Button
                    variant="primary"
                    onClick={() => {
                      setShowVariantListModal(false);
                      handleAddVariantClick(selectedProductForVariant);
                    }}
                  >
                    <i className="fas fa-plus me-2"></i>Add First Variant
                  </Button>
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Image</th>
                        <th>Variant Name</th>
                        <th>Code</th>
                        <th>UOM</th>
                        <th>Gross Weight</th>
                        <th>Qty Count</th>
                        <th>Unit Price</th>
                        <th>Profit (%)</th>
                        <th>Final Price</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {variants.map((variant, idx) => (
                        <tr key={variant.id}>
                          <td>{idx + 1}</td>
                          <td>
                            <img
                              src={
                                variant.variant_image
                                  ? `${image_api}${variant.variant_image.replace(/^test\//, "")}`
                                  : defaultImg
                              }
                              alt="variant"
                              width="40"
                              height="40"
                              className="rounded"
                            />
                          </td>
                          <td>{variant.variant_name}</td>
                          <td>{variant.veemart_variant_code || "-"}</td>
                          <td>{variant.uom || "-"}</td>
                          <td>{variant.gross_weight || "-"}</td>
                          <td>{variant.qty_count || "-"}</td>
                          <td>{variant.unit_price || "-"}</td>
                          <td>{variant.business_profit || "-"}</td>
                          <td>{variant.final_selling_price || "-"}</td>
                          <td>
                            <span
                              className={`badge ${
                                variant.active_status === 1 ? "bg-success" : "bg-danger"
                              }`}
                            >
                              {variant.active_status === 1 ? "Active" : "Inactive"}
                            </span>
                          </td>
                          <td>
                            <Button
                              size="sm"
                              variant="primary"
                              onClick={() => handleEditVariantClick(variant)}
                            >
                              <i className="fas fa-pencil-alt"></i>
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                onClick={() => {
                  setShowVariantListModal(false);
                  handleAddVariantClick(selectedProductForVariant);
                }}
              >
                <i className="fas fa-plus me-2"></i>Add New Variant
              </Button>
              <Button variant="secondary" onClick={() => setShowVariantListModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>

        </Card.Body>
      </Card>
      <style>
        {`
          .stay-btn {
            background-color: #007bff;
            color: white;
            border: none;
            padding: 8px 20px;
            border-radius: 6px;
            font-weight: 600;
            transition: background-color 0.3s ease;
          }
          .stay-btn:hover {
            background-color: #0056b3;
          }

          .leave-btn {
            background-color: #6c757d;
            color: white;
            border: none;
            padding: 8px 20px;
            border-radius: 6px;
            font-weight: 600;
            transition: background-color 0.3s ease;
          }
          .leave-btn:hover {
            background-color: #5a6268;
          }
        `}
      </style>

      <ToastContainer />
    </>
  );
};

export default ProductMaster;